import styled, { keyframes } from "styled-components"

const spinner = keyframes`
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
`

const LoadingSpinner = styled.div`
  width: 50px;
  height: 50px;
  border: 10px solid #f3f3f3; /* Light grey */
  border-top: 10px solid #002c98; /* Blue */
  border-radius: 50%;
  animation: ${spinner} 1.5s linear infinite;
`

const SpinnerContainer = styled.div`
  display: grid;
  justify-content: center;
  align-items: center;
  height: 350px;
`

export default function Spinner() {
  return (
    <SpinnerContainer>
      <LoadingSpinner />
    </SpinnerContainer>
  )
}
